<template>
	<div class="px-4">
		<span id="reservation-detail"></span>
		<!-- HEADER -->
		<wrapper-mobile-view>
			<div class="w-100 bg-white py-3 px-4 border-b-semi-grey">
				<div class="w-100">
					<div class="row">
						<div class="col-1 align-self-center">
							<div @click="backTo()" class="d-inline-grid cursor-pointer">
                <img src="../../../assets/img/icon/back.png" alt="Back" class="mt-1" width="20">
              </div>
						</div>
						<div class="col-9 align-self-center">
							<p class="mb-0 body-1-2">Reservation List</p>
						</div>
					</div>
				</div>
			</div>
		</wrapper-mobile-view>
		<block :height="57" />

		<!-- LIST -->
		<div v-if="is_load" class="w-100 py-4 text-center">
      <loader />
    </div>
    <template v-else>
    	<div class="py-4" v-if="error != ''">
      	<ErrorMessage :message="error" />
    	</div>
    	<div class="w-100">
    		<div class="mb-3 radius-8 p-3" :class="isRsvActive(rsv.booking_number) ? 'border border-success bg-green-light' : 'border-semi-grey'" v-for="(rsv,index) in reservations">
    			<div class="row">
            <div class="col-7">
              <p class="mb-0 overline text-success" v-if="isRsvActive(rsv.booking_number)">ACTIVE</p>
              <p class="mb-0 body-2-2 font-bold">{{rsv.booking_number}}</p>
            </div>
            <div class="col-5 text-right">
              <p class="mb-0 body-2-2 font-semibold text-12" :class="statusReservationParsing(rsv).text_color">{{statusReservationParsing(rsv).title}}</p>
            </div>
            <div class="col-12 my-3">
            	<div class="w-100 border-2-bottom-dashed"></div>
            </div>
          </div>
          <div class="row">
          	<div class="col-6 mb-3">
              <p class="mb-0 body-3">{{$t("hotel.date.check-in")}}</p>
              <p class="mb-0 body-3-1 text-truncate">{{$formatDate(rsv.arrival_date,'YYYY-MM-DD')}}</p>
            </div>
            <div class="col-6 mb-3">
              <p class="mb-0 body-3">{{$t("hotel.date.check-out")}}</p>
              <p class="mb-0 body-3-1 text-truncate">{{$formatDate(rsv.departure_date,'YYYY-MM-DD')}}</p>
            </div>
            <div class="col-6">
              <p class="mb-0 body-3">{{$t("hotel.success.transaction-date")}}</p>
              <p class="mb-0 body-3-1">{{$formatDate(rsv.reservation_date)}}</p>
            </div>
            <div class="col-6">
              <p class="mb-0 body-3">Total Guests</p>
              <p class="mb-0 body-3-1 text-truncate">{{rsv.adult}} {{$t('hotel.adults.adults')}}<template v-if="rsv.child > 0">, {{rsv.child}} {{$t('hotel.children.children')}}</template></p>
            </div>
          </div>
    		</div>
    		<div class="w-100 mt-4 text-center" v-if="pagination.last_page > 1">
    			<b-pagination
          	class="d-inline-block"
			      v-model="pagination.current_page"
			      :total-rows="pagination.total"
			      :per-page="pagination.per_page"
			    ></b-pagination>
    		</div>
    	</div>
    </template>
	</div>
</template>
<script>
	import {mapGetters} from "vuex";
	import {get} from '@/services/index.js';
	import moment from 'moment'

	export default{
		data(){
			return{
				is_load: true,
				error: '',
				reservations:[],
				pagination:{
					per_page: 10,
	        total: 0,
	        current_page: 1,
	        last_page: 3, 
				}
			}
		},
		computed:{
			...mapGetters(['getMerchant','isReservationActive','getReservationActive']),
			current_page(){
				return this.pagination.current_page
			}
		},
		watch:{
			current_page(){
				this.loadReservationList()
			}
		},
		mounted(){
			this.$smoothScroll('reservation-detail')
			this.loadReservationList()
		},
		methods:{
			backTo(){
				this.$emit('back')
			},
			statusReservationParsing(data){
				let return_data = {
					title: '',
					text_color: ''
				}
				if(data.status == 'CHECKOUT'){
					return_data = {
						title: 'Check Out',
						text_color: 'text-orange'
					}
				}else if(data.status == 'CANCELLED'){
					return_data = {
						title: 'Cancelled',
						text_color: 'text-danger'
					}
				}else{
					let today_end = moment().endOf("day").toDate()
					let invalid_departure_date_end = moment(data.departure_date,'YYYY-MM-DD').endOf("day").toDate()
					let invalid_departure_date = moment(today_end).isAfter(invalid_departure_date_end)
					if(invalid_departure_date){
						return_data = {
							title: 'Expired',
							text_color: 'text-danger'
						}
					}else{
						if(data.status == 'NEW_RESERVATION'){
							return_data = {
								title: 'New Reservation',
								text_color: 'text-warning'
							}
						}else if(data.status == 'SUBMIT_FORM'){
							return_data = {
								title: 'Waiting for Approval',
								text_color: 'text-warning'
							}
						}else if(data.status == 'PRE_CHECKIN'){
							return_data = {
								title: 'Pre Check In',
								text_color: 'text-info'
							}
						}else if(data.status == 'CHECKIN'){
							return_data = {
								title: 'Check In',
								text_color: 'text-success'
							}
						}else{
							return_data = {
								title: data.status,
								text_color: 'text-green'
							}
						}
					}
				}
				return return_data
			},
			loadReservationList(){
				this.is_load = true
				this.error = ''
				get("CONCIERGE",'reservation',{
					merchant_id: this.getMerchant.id,
					status: 'NEW_RESERVATION,SUBMIT_FORM,PRE_CHECKIN,CHECKIN,CHECKOUT,CANCELLED',
					datetime_type: 'NO_USE_FILTER_DATE',
					start_datetime: moment().format("YYYY-MM-DD HH:mm:ss"),
					end_datetime: moment().format("YYYY-MM-DD HH:mm:ss"),
					page_size: this.pagination.per_page,
					page: this.pagination.current_page
				}).then(response=>{
					let res = response.data
					if(res.success){
						this.pagination = {
							per_page: res.per_page,
			        total: res.total,
			        current_page: res.current_page,
			        last_page: res.last_page, 
						}
						this.reservations = res.data
					}else{
						this.error = res.message
					}
					this.is_load = false
				})
			},
			isRsvActive(booking_number){
				return this.isReservationActive && this.getReservationActive.booking_number == booking_number
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/pages/general/account/ReservationList.vue